import React, { Component } from 'react';
import moment from 'moment';
import { formatDate } from 'components/util';
import DatePickerLabel from 'components/date-picker-label';
import DatePicker from 'components/date-picker';
import Button from 'components/button';
import enhance from '../enhance';

class SelectDates extends Component {
  render() {
    const {
      startDate,
      endDate,
      setStartDate,
      setEndDate,
      scheduleEvent
    } = this.props;

    const isValid = moment(startDate) < moment(endDate);

    return (
      <div className="select-dates" style={{ width: '100%', height: '185px' }}>
        <div className="date-row">
          <DatePickerLabel lineHeight="30px" name="add to calendar">
            Start Date
          </DatePickerLabel>
          <DatePicker
            text={formatDate(startDate || moment())}
            selectingType="startDate"
            otherType="endDate"
            startDate={startDate}
            endDate={endDate}
            setEventDate={setStartDate}
          />
        </div>
        <div className="date-row">
          <DatePickerLabel lineHeight="30px" name="remove from calendar">
            End Date
          </DatePickerLabel>
          <DatePicker
            text={formatDate(endDate || moment())}
            selectingType="endDate"
            otherType="startDate"
            startDate={startDate}
            endDate={endDate}
            setEventDate={setEndDate}
          />
        </div>
        <Button onClick={scheduleEvent} disabled={!isValid}>
          SCHEDULE
        </Button>
      </div>
    );
  }
}

export default enhance(SelectDates);



// WEBPACK FOOTER //
// ./src/components/create/select-dates/index.js